module.exports = __webpack_public_path__ + "ca1de6ba387bdfae22ecb7a0f04c1c1f.MP3";